import React, { useState, useEffect } from "react";
import Swal from 'sweetalert2'
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Col, Button } from "react-bootstrap";
import UserSidebar from "../../Component/UserSidebar";
import { agent } from "../../utils/agent";
import { imgPath } from "../../utils/imagePath";
import { ASSIGN_MENTOR_REQUEST } from "../../utils/apiPath";
import Relationship from "./relationship";
import { Tooltip } from "@mui/material";
import config from "../../config";
import queryString from "query-string";
import PopupModalWithOk from "../../utils/helpers/popupModalOk";
import { loadRegPendingRequestData } from "./Slice/menteesRequestSlice";
import PropTypes from "prop-types";
import { getSubdomainPath, UCWords } from "../../utils/helpers";

function SidebarAddClass() {
  document.getElementById("OnscrollBody").classList.toggle("show_sidebar");
}

const Index = (props) => {

  const dispatch = useDispatch();
  const { menteeRequestData, pagination, steps_labels } = useSelector((state) => state?.menteesRequest);
  const { title, actions } = props;
  const [relationModalShow, setRelationModalShow] = useState(false);
  const [endRelationship, setEndRelationship] = useState({});
  const [getAcceptLoader, setGetAcceptLoader] = useState({});
  const [getRejectLoader, setGetRejectLoader] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");

  const subDomainPath = getSubdomainPath();

  const isEmptyValue = (value) => {
    return (
      value === null ||
      value === undefined ||
      value === "" ||
      value === "null" ||
      value === "undefined" ||
      (Array.isArray(value) && value.length === 0)
    );
  };

  const getDynamicValue = (item, key) => {
    if (item?.reg_fields && Object.hasOwn(item.reg_fields, key)) {
      return item.reg_fields[key];
    }
    if (item?.reg_feilds && Object.hasOwn(item.reg_feilds, key)) {
      return item.reg_feilds[key];
    }
    return item?.[key];
  };

  const getRegFeildsOrderedKeys = (item) => {
    if (Array.isArray(item?.reg_feilds)) {
      return item.reg_feilds.flatMap((step) =>
        Array.isArray(step?.reg_feilds)
          ? step.reg_feilds.map((field) => field.reg_key)
          : []
      );
    }

    if (item?.reg_feilds && typeof item.reg_feilds === "object") {
      return Object.keys(item.reg_feilds);
    }

    return [];
  };

  const dynamicFieldReservedKeys = new Set([
    "image",
    "resume",
    "is_privacy",
    "first_name",
    "last_name",
    "full_name",
    "country_image_path",
    "user_availability_check",
    "is_reached_limit",
    "all_main_area",
    "all_sub_area",
    "reg_fields",
    "reg_feilds",
    "fields",
    "labels",
    "mentor_id",
    "mentee_id",
    "status",
    "session_start_date",
    "session_end_date",
    "mentee_review",
    "mentee_name",
    // "mentee_organization",
    // "mentee_position",
    "mentee_linkedin",
    "mentee_image",
    "created_at",
    "updated_at",
    "reason",
    "is_completed",
    "mentor_name",
    "mentor_role",
    "mantee_main_area",
    "mentor_main_area",
    "mantee_all_main_area",
    "mentor_all_main_area",
    "mantee_sub_area",
    "mentor_review",
    "mentor_termination_status",
    "mentee_termination_status",
    "date",
    "s_end_date",
    // "mentors_organization",
    // "mentors_position",
    "mentors_linkedin",
    "mentors_image",
    "mentors_about",
    "mentee_diagnostics",
    "mentee_diagnostics_sdate",
    "mf_mental_health",
    "mf_certified_coach",
    "mentor_lgbtq_discussion",
    "lgbtq_discussion",
    "mentor_sessions",
    "mentee_sessions",
    "any_particular_program",
    "any_particular_program_data",
    "linkedin",
    "mn_open_to_talk",
    "mn_loking_for_coach",
    // "position",
    // "organization"
  ]);

  const keyGroups = {
    objective: ["objective"],
    board_entity_type: ["board_entity_type", "mentee_board_entity_type"],
    years_of_board_experience: [
      "years_of_board_experience",
      "mentee_years_of_board_experience",
    ],
    accredited_director: [
      "accredited_director",
      "mentee_accredited_director",
    ],
    course_completed: [
      "course_completed",
      "mentee_course_completed",
    ],
    past_board_roles: [
      "past_board_roles",
      "board_roles",
    ],
    domains: [
      "domains",
      "mantee_main_area",
      "mantee_all_main_area",
    ],
    sub_domains: [
      "sub_domains",
      "mantee_sub_area",
    ],
    program_study_id: [
      "program_study_id",
      "mentee_program_study_id_data",
      "mentee_program_study_other",
    ],
    about: ["about", "mentee_about"],
    resume: ["resume", "mentee_resume"],
  };

  const getBaseKeys = (item, orderedKeys) => {
    if (orderedKeys.length > 0) {
      return orderedKeys.filter(
        (key) => !dynamicFieldReservedKeys.has(key)
      );
    }

    if (item?.reg_fields) {
      return Object.keys(item.reg_fields).filter(
        (key) => !dynamicFieldReservedKeys.has(key)
      );
    }

    return [
      "objective",
      "board_entity_type",
      "years_of_board_experience",
      "accredited_director",
      "course_completed",
      "past_board_roles",
      "domains",
      "sub_domains",
      "program_study_id",
      "about",
    ];
  };

  const getGroupName = (key) =>
    Object.keys(keyGroups).find((group) =>
      keyGroups[group].includes(key)
    );

  const getDynamicFieldKeys = (item) => {
    const orderedKeys =
      getRegFeildsOrderedKeys(item);

    const keysToUse = getBaseKeys(
      item,
      orderedKeys
    );

    const seenGroups = new Set();

    return keysToUse.reduce(
      (result, key) => {
        const groupName = getGroupName(key);

        if (groupName) {
          if (!seenGroups.has(groupName)) {
            seenGroups.add(groupName);
            result.push(groupName);
          }
        } else if (!result.includes(key)) {
          result.push(key);
        }

        return result;
      },
      []
    );
  };

  const dynamicFieldsLabels = {
    objective: "Objectives",
    board_entity_type: "Board Entity Type Experience",
    years_of_board_experience: "Year of Board Experience",
    accredited_director: "SID Accredited Director",
    course_completed: "Course Completed",
    past_board_roles: "Current / Past Board Roles",
    domains: "Domains",
    sub_domains: "Sub Domains",
    program_study_id: "Program of study",
    about: "About me",
    resume: "Resume"
  };

  const getRegFieldLabel = (regFields, key) => {
    const found = regFields
      ?.flatMap((step) => step?.reg_feilds || [])
      ?.find((field) => field.reg_key === key);

    return (
      found?.label ||
      found?.reg_label ||
      found?.label_name ||
      found?.name
    );
  };

  const getDynamicFieldLabel = (item, key) => {
    const regFieldLabel = getRegFieldLabel(
      item?.reg_feilds,
      key
    );

    return (
      steps_labels?.[key] ||
      item?.fields?.[key] ||
      regFieldLabel ||
      item?.reg_feilds?.[key] ||
      dynamicFieldsLabels?.[key] ||
      UCWords(key.replaceAll("_", " "))
    );
  };

  const renderResumeField = (item, key) => {
    if (key === "resume" || key === "mentee_resume") {
      const resumeUrl = item.mentee_resume || item.reg_fields?.resume || item.resume;
      if (isEmptyValue(resumeUrl)) return null;
      return (
        <div className="mentro_text" key={key}>
          <h3 className="mb-1">{getDynamicFieldLabel(item, key)}</h3>
          <div className="d-flex align-items-center mt-2">
            <div className="date_icon me-2">
              <img
                src="/assets/images/pdf.png"
                alt="resume"
                style={{ width: "24px", height: "24px" }}
              />
            </div>
            <Link
              to=""
              className="date color_red"
              style={{
                textDecoration: "underline",
                fontWeight: "500"
              }}
              onClick={(e) => downloadResume(e, resumeUrl)}
            >
              Download Resume
            </Link>
          </div>
        </div>
      );
    }
  }

  const renderObjectiveField = (item, key) => {
    if (key === "objective") {
      let objectives = [];
      if (item.reg_fields?.objective) {
        objectives = item.reg_fields.objective
          .split("||")
          .map((o) => o.trim())
          .filter(Boolean);
      }
      if (objectives.length === 0) return null;
      return (
        <div className="mentro_text" key={key}>
          <h3 className="mb-1">{getDynamicFieldLabel(item, key)}</h3>
          <ul>
            {objectives.map((obj, idx) => (
              <li key={obj.id}>{obj}</li>
            ))}
          </ul>
        </div>
      );
    }
  }

  const renderBoardField = (item, key) => {
    if (
      key === "board_entity_type" ||
      key === "accredited_director" ||
      key === "course_completed"
    ) {
      let rawVal = null;
      if (key === "board_entity_type") {
        rawVal = item.mentee_board_entity_type || item.reg_fields?.board_entity_type || item.board_entity_type;
      } else if (key === "accredited_director") {
        rawVal = item.mentee_accredited_director || item.reg_fields?.accredited_director || item.accredited_director;
      } else if (key === "course_completed") {
        rawVal = item.mentee_course_completed || item.reg_fields?.course_completed || item.course_completed;
      }

      let items = [];
      if (Array.isArray(rawVal)) {
        items = rawVal.map(v => typeof v === "object" ? (v.title || v.name || v.label || "") : v).filter(Boolean);
      } else if (typeof rawVal === "string") {
        items = rawVal.split("||").flatMap(v => v.split(",")).map(v => v.trim()).filter(Boolean);
      }

      if (items.length === 0) return null;
      return (
        <div className="mentro_text" key={key}>
          <h3 className="mb-1">{getDynamicFieldLabel(item, key)}</h3>
          <ul>
            {items.map((val, idx) => (
              <li key={val.id}>{val}</li>
            ))}
          </ul>
        </div>
      );
    }
  }

  const renderYearsofBoardExperienceField = (item, key) => {
    if (key === "years_of_board_experience" || key === "mentee_years_of_board_experience") {
      const val = item.mentee_years_of_board_experience || item.reg_fields?.years_of_board_experience || item.years_of_board_experience;
      if (isEmptyValue(val)) return null;
      return (
        <div className="mentro_text" key={key}>
          <h3 className="mb-1">{getDynamicFieldLabel(item, key)}</h3>
          <ul>
            <li>{val}</li>
          </ul>
        </div>
      );
    }
  }

  // const renderPastBoardRolesField = (item, key) => {
  //   if (key === "past_board_roles") {
  //     const pastBoardRolesStr = item.reg_fields?.past_board_roles || item.past_board_roles || "";
  //     const boardRolesArr = item.reg_fields?.board_roles || item.board_roles || [];
  //     if (!pastBoardRolesStr && (!Array.isArray(boardRolesArr) || boardRolesArr.length === 0)) return null;
  //     return (
  //       <div className="mentro_text" key={key}>
  //         <h3 className="mb-1">{getDynamicFieldLabel(item, key)}</h3>
  //         <ul>
  //           {pastBoardRolesStr
  //             ?.split(",")
  //             ?.slice(0, 3)
  //             ?.map((role, index) => (
  //               <li key={role.id}>{role.trim()}</li>
  //             ))}
  //           {boardRolesArr?.map((role, index) => (
  //             <li key={role.id || index}>
  //               <strong>{role.rep_board_title}</strong> at {role.rep_company_name}
  //               {role.rep_start_date && (
  //                 <span>
  //                   {" "}
  //                   ({role.rep_start_date} - {role.rep_end_date || "Present"})
  //                 </span>
  //               )}
  //             </li>
  //           ))}
  //         </ul>
  //         {pastBoardRolesStr && pastBoardRolesStr.split(',').length > 3 && (
  //           <p className="text-muted" style={{ fontSize: '12px', marginTop: '5px' }}>
  //             +{pastBoardRolesStr.split(',').length - 3} more
  //           </p>
  //         )}
  //       </div>
  //     );
  //   }
  // }

    const renderPastBoardRolesField = (item, key) => {
    if (key === "past_board_roles") {
      const pastBoardRolesStr = item.reg_fields?.past_board_roles || item.past_board_roles || "";
      let pastBoardRolesList = [];
      if (Array.isArray(pastBoardRolesStr)) {
        pastBoardRolesList = pastBoardRolesStr;
      } else if (typeof pastBoardRolesStr === "string") {
        if (pastBoardRolesStr.includes("||")) {
          pastBoardRolesList = pastBoardRolesStr.split("||").map((d) => d.trim()).filter(Boolean);
        } else if (pastBoardRolesStr.trim()) {
          pastBoardRolesList = [pastBoardRolesStr.trim()];
        }
      }
      if (pastBoardRolesList.length === 0) return null;
      const label = getDynamicFieldLabel(item, key);
      return (
        <div key={key}>
          <h3 className="mb-1">{label == "Past Board Roles" ? "Current / Past Board Roles" : label}</h3>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px", marginBottom: "10px" }}>
            {pastBoardRolesList.map((pastBoardRole, idx) => {
              const text = typeof pastBoardRole === "object"
                ? `${pastBoardRole.rep_company_name ? pastBoardRole.rep_company_name + " – " : ""}${pastBoardRole.rep_board_title || ""}`
                : pastBoardRole;
              return (
                <li key={idx} style={{ listStyleType: "disc", marginBottom: "4px", fontSize: "14px" }}>
                  {text}
                </li>
              );
            })}
          </ul>
        </div>
      );
    }
  }

  const renderDomainsField = (item, key) => {
    if (key === "domains" || key === "mantee_main_area" || key === "mantee_all_main_area") {
      const domainsStr = item.mantee_all_main_area || item.reg_fields?.domains || item.mantee_main_area || "";
      const domainsList = domainsStr ? domainsStr.split('||').map(d => d.trim()).filter(Boolean) : [];
      if (domainsList.length === 0) return null;
      return (
        <div className="mentro_text" key={key}>
          <h3 className="mb-1">{getDynamicFieldLabel(item, key)}</h3>
          <ul>
            {domainsList.map((domain, idx) => (
              <li key={domain.id}>{domain}</li>
            ))}
          </ul>
        </div>
      );
    }
  }

  const renderSubDomainsField = (item, key) => {
    if (key === "sub_domains" || key === "mantee_sub_area") {
      const subDomainsStr = item.mantee_sub_area || item.reg_fields?.sub_domains || "";
      const subDomainsList = subDomainsStr ? subDomainsStr.split(',').map(s => s.trim()).filter(Boolean) : [];
      if (subDomainsList.length === 0) return null;
      return (
        <div className="mentro_text" key={key}>
          <h3 className="mb-1">{getDynamicFieldLabel(item, key)}</h3>
          <ul>
            {subDomainsList.map((subDomain, idx) => (
              <li key={subDomain.id}>{subDomain}</li>
            ))}
          </ul>
        </div>
      );
    }
  };

  const renderProgramStudyField = (item, key) => {
    if (key === "program_study_id" || key === "mentee_program_study_id_data" || key === "mentee_program_study_other") {
      const val = item?.mentee_program_study_other || item?.mentee_program_study_id_data || item?.reg_fields?.program_study_id;
      if (isEmptyValue(val)) return null;
      return (
        <div className="mentro_text" key={key}>
          <h3 className="mb-1">{getDynamicFieldLabel(item, key)}</h3>
          <ul>
            <li>{val}</li>
          </ul>
        </div>
      );
    }
  }

  const renderAboutField = (item, key) => {
    if (key === "about" || key === "mentee_about") {
      const val = item?.mentee_about || item?.reg_fields?.about;
      if (isEmptyValue(val)) return null;
      return (
        <div className="mentro_text" key={key}>
          <h3 className="mb-1">{getDynamicFieldLabel(item, key)}</h3>
          <div className="about-text">
            <p>{val}</p>
          </div>
        </div>
      );
    }
  }

  const renderDefaultField = (item, key) => {
    const val = getDynamicValue(item, key);

    if (isEmptyValue(val)) return null;

    return (
      <div className="mentro_text" key={key}>
        <h3 className="mb-1">
          {getDynamicFieldLabel(item, key)}
        </h3>
        <ul>
          <li>{typeof val === "object"
            ? JSON.stringify(val)
            : String(val)}</li>
        </ul>
      </div>
    );
  };

  const renderDynamicField = (item, key) => {
    const fieldRenderers = {
      resume: renderResumeField,
      mentee_resume: renderResumeField,

      objective: renderObjectiveField,
      mentee_objective: renderObjectiveField,

      board_entity_type: renderBoardField,
      accredited_director: renderBoardField,
      course_completed: renderBoardField,

      years_of_board_experience: renderYearsofBoardExperienceField,
      mentee_years_of_board_experience: renderYearsofBoardExperienceField,

      past_board_roles: renderPastBoardRolesField,
      domains: renderDomainsField,
      mantee_main_area: renderDomainsField,
      mantee_all_main_area: renderDomainsField,

      sub_domains: renderSubDomainsField,
      mantee_sub_area: renderSubDomainsField,

      program_study_id: renderProgramStudyField,
      mentee_program_study_id_data: renderProgramStudyField,
      mentee_program_study_other: renderProgramStudyField,

      about: renderAboutField,
      mentee_about: renderAboutField,
    };

    const renderer = fieldRenderers[key];

    return renderer
      ? renderer(item, key)
      : renderDefaultField(item, key);
  };

  const downloadResume = (e, url) => {
    e.preventDefault();
    window.open(url, "_blank");
  };

  const submitAcceptReject = async (menteeId, data) => {
    try {
      setGetAcceptLoader((prev) => ({ ...prev, [menteeId]: true }));
      const res = await agent.post(ASSIGN_MENTOR_REQUEST, data);
      setPopupMessage(res.data.message);
      setShowPopup(true);
      setTimeout(() => {
        history("/mentees-request");
      }, 1500);
    } catch (error) {
      console.error(error);
    } finally {
      setGetAcceptLoader((prev) => ({ ...prev, [menteeId]: false }));
    }
  };

  const AcceptReject = async (menteeId, mentorId, status, actionid) => {
    const data = {
      mentee_id: menteeId,
      mentor_id: mentorId,
      status,
      actionid,
    };

    const result = await Swal.fire({
      html: "<b>Are you sure you want to accept request?</b>",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      confirmButtonText: "Yes",
      cancelButtonColor: "#d33",
    });

    if (!result.isConfirmed) {
      return;
    }

    await submitAcceptReject(menteeId, data);
  };


  const rejectWithReason = (menteeId, mentorId, status, actionid) => {
    setGetRejectLoader(true);
    setRelationModalShow(true);
    setEndRelationship({
      mentee_id: menteeId,
      mentor_id: mentorId,
      status: status,
      actionid: actionid,
    });
  };
  const location = useLocation();
  const history = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const queryStringParsed = queryString.parse(location.search);
    const request = {};
    if (params.get("sort")) {
      const sort = queryStringParsed["sort"];
      const direction = queryStringParsed["direction"];
      request.sort = sort;
      request.direction = direction;
    }
    if (params.get("page")) {
      const page = queryStringParsed["page"];
      request.page = page;
    }
    if (params.get("keyword")) {
      const keyword = queryStringParsed["keyword"];
      request.keyword = keyword;
    }
    document.title = title;
    async function fetchData() {
      try {
        await dispatch(
          // loadPendingRequestData({
          //   request,
          //   status: 1,
          // })
          loadRegPendingRequestData({
            request,
            status: 1,
          })
        ).unwrap();
      } catch (error) {
        console.error("Failed to load pending requests", error);
      }
    }
    fetchData();
  }, [title, actions, location, dispatch]);

  return (

    <div>
      <div className="dashboard_outer">
        <UserSidebar />
        <div className="dashboard_inner">
          <div className="d-block mb-3 mb-md-0 mb-md-none toggle_btn_outer">
            <Link onClick={SidebarAddClass} className="toggle_btn d-lg-none">
              <i className="fas fa-bars"></i>
            </Link>
          </div>
          <h2 className="dash_heading">Pending Request</h2>
          <div className="box_wrap shadow-sm bg-white mentor_box">
            {(Array.isArray(menteeRequestData) ? menteeRequestData : []).map((item, key) => (
              <div
                  className="mentro_details mb-2 mb-md-4 d-flex  flex-wrap"
                  key={item.id}
                >
                  <div className="mentro_details_leftbar">
                    <div className="mentor_pic">
                      <img
                        src={item.mentee_image}
                        alt="women's career consultation"
                      />
                    </div>
                    {item?.reg_fields?.linkedin && <div className="profile_btn mt-3">
                      <a
                        href={item.reg_fields?.linkedin}
                        className="link_btn btn btn_red m-0"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={imgPath + "linkedin.png"}
                          className="me-2 bg-white"
                          alt="LinkedIn"
                        />{" "}
                        Linkedin Profile
                      </a>
                    </div>}
                    <div className="extar_info_link">
                      <ul className="px-0 pt-2 mentor_log">
                        {subDomainPath !== 'siddev' && Number(item?.mn_open_to_talk) === 1 && (
                          <li>
                            <Tooltip
                              size="4xl"
                              title={<h5>{config?.mn_open_to_talk}</h5>}
                              describeChild
                              arrow
                            >
                              <img alt="" src={imgPath + "usermind.svg"} />
                            </Tooltip>
                          </li>
                        )}
                        {subDomainPath !== 'siddev' && Number(item?.mn_loking_for_coach) === 1 && (
                          <li>
                            <Tooltip
                              size="4xl"
                              title={<h5>{config?.mn_loking_for_coach}</h5>}
                              describeChild
                              arrow
                            >
                              {/* <img alt="" src={imgPath + "usercoach.svg"} /> */}
                              <img src={imgPath + "useraward.svg"} alt="User award icon" />
                            </Tooltip>
                          </li>
                        )}
                      </ul>
                    </div>
                  </div>
                  <div className="mentro_details_sidebar">
                    <div className="row">
                      <Col xl={4}>
                        <div className="d-flex ">
                          <div className="name_info" style={{ marginBottom: "40px" }}>
                            <h4>{item.mentee_name}</h4>
                            {/* <h5>
                              <span className="d-block">
                                {item.mentee_organization}
                              </span>
                              {item.mentee_position}
                            </h5> */}
                          </div>
                        </div>
                      </Col>
                      <Col xl={8} className="">
                        <div className="profile_btn d-sm-flex  justify-content-xl-end">
                          {item.mentee_resume && (
                            <div className="d-sm-flex align-items-center">
                              <div className="date_icon">
                                <img
                                  src="/assets/images/pdf.png"
                                  alt="women leadership mentoring"
                                />
                              </div>

                              {item.mentee_resume && (
                                <div className="date_content ps-2">
                                  <Link
                                    to=""
                                    download
                                    className="d-block date color_red"
                                    onClick={(e) =>
                                      downloadResume(e, item.mentee_resume)
                                    }
                                    target="_blank"
                                  >
                                    {"Download Resume"}
                                  </Link>
                                </div>
                              )}
                            </div>
                          )}
                          <Button
                            className="link_btn btn btn_red"
                            onClick={() =>
                              AcceptReject(
                                item.mentee_id,
                                item.mentor_id,
                                2,
                                item.id
                              )
                            }
                            disabled={getAcceptLoader[item.mentee_id]}
                          >
                            {getAcceptLoader[item.mentee_id] ? "Accepting.." : "Accept"}
                          </Button>
                          <Button
                            className="link_btn btn btn_red"
                            onClick={() =>
                              rejectWithReason(
                                item?.mentee_id,
                                item?.mentor_id,
                                3,
                                item?.id
                              )
                            }
                            disabled={getAcceptLoader[item.mentee_id]}
                          >
                            {getRejectLoader ? "Rejecting.." : "Reject"}
                          </Button>
                        </div>
                      </Col>
                    </div>

                    {getDynamicFieldKeys(item).map((key) => renderDynamicField(item, key))}
                  </div>
                </div>
              ))}
            {(menteeRequestData.length === 0 || pagination?.total === 0) && (
              <div className="text-center">No pending request found.</div>
            )}
          </div>
        </div>
      </div>
      {relationModalShow && (
        <Relationship
          show={relationModalShow}
          endrelationship={endRelationship}
          actions={actions}
          onHide={() => {
            setRelationModalShow(false);
            setGetRejectLoader(false);
          }}
          centered
          size="xl"
          className="mentor_modal mentor_model_custom"
        />
      )}

      <PopupModalWithOk
        show={showPopup}
        onHide={() => setShowPopup(false)}
        message={popupMessage}
        showConfirm={false}
        staticBackdrop={true}
      />

    </div>
  );
};

Index.propTypes = {
  title: PropTypes.string.isRequired,
  actions: PropTypes.object.isRequired,
};

export default Index;
